import { render } from "./ExpiredPage.vue?vue&type=template&id=48ac2b4b&scoped=true"
import script from "./ExpiredPage.vue?vue&type=script&lang=js"
export * from "./ExpiredPage.vue?vue&type=script&lang=js"

import "./ExpiredPage.vue?vue&type=style&index=0&id=48ac2b4b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ac2b4b"]])

export default __exports__